import { render, staticRenderFns } from "./AddGoals.vue?vue&type=template&id=e1fe41e4&scoped=true&"
import script from "./AddGoals.vue?vue&type=script&lang=js&"
export * from "./AddGoals.vue?vue&type=script&lang=js&"
import style0 from "./AddGoals.vue?vue&type=style&index=0&id=e1fe41e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1fe41e4",
  null
  
)

export default component.exports